import img1 from "./imgs/footer.webp";
import { Link } from "react-router-dom";


// ES5 Arrow Function
function Footer() {
 const styles = {
  footer: {
   marginBottom: 50,
  },
  container: {
   display: "flex",
   justifyContent: "space-evenly",
   marginTop: "50px",
  },
  column: {
   marginLeft: "6%",
  },
  li: {
   listStyleType: "none",
   color: "black",
   fontFamily: "Karla",
   fontSize: 17,
   textDecoration: "none",
  },
  img: {
   width: 280,
  },
 };
 return (
  <>
  {/* <footer>Footer
  <nav> */}
   {/* 
   <ul>
   jsx-a11y/anchor-is-valid
   <li><a href=""></a></li>
   <li><a href=""></a></li>
   <li><a href=""></a></li>
   <li><a href=""></a></li>
  </ul> */}
 {/* </nav>
  </footer> */}
   <footer style={styles.footer}>
   <img src={img1} alt="banner-footer" style={styles.img} />
   <aside style={styles.container}>
    <div style={styles.column}>
     <h4>Doormat Navigation</h4>
     <ul>
      <li style={styles.li}>
       <Link to="/">Home</Link>
      </li>
      <li style={styles.li}>
       <Link to="/about">About</Link>
      </li>
      <li style={styles.li}>
       <Link to="/menu">Menu</Link>
      </li>
      <li style={styles.li}>
       <Link to="/reservations">Reservations</Link>
      </li>
      <li style={styles.li}>
       <Link to="/order-online">Order Online</Link>
      </li>
      <li style={styles.li}>
       <Link to="/login">Login</Link>
      </li>
     </ul>
    </div>

    <div style={styles.column}>
     <h4>Contact info</h4>
     <ul>
      <li style={styles.li}>
       <address>1279 North Bend River Road</address>
      </li>
      <li style={styles.li}>03-47474478</li>
      <li style={styles.li}>little.lemon@shoper.com</li>
     </ul>
    </div>

    <div style={styles.column}>
     <h4>Social Media Links</h4>
     <ul>
      <li style={styles.li}>606-848-9474</li>
      <li style={styles.li}>little.lemon@gmail.com</li>
     </ul>
    </div>
   </aside>
  </footer>
  </>
 );
}

export default Footer;
